"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootLayout = RootLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = require("../pages/layout/navigation");
const layout_1 = require("../pages/layout");
const useIsMobile_1 = require("../hooks/mobile/useIsMobile");
const MobileLayout_1 = require("./MobileLayout");
function RootLayout() {
    const [sidebarVisible, setSidebarVisible] = (0, react_1.useState)(false);
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const toggleSidebar = () => {
        setSidebarVisible((prev) => !prev);
    };
    if (isMobile) {
        return (0, jsx_runtime_1.jsx)(MobileLayout_1.MobileLayout, {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "h-screen flex flex-col scrollbar-hidden", children: [(0, jsx_runtime_1.jsx)(navigation_1.NavigationComponent, { sidebarVisible: sidebarVisible, toggleSidebar: toggleSidebar }), (0, jsx_runtime_1.jsx)(layout_1.Main, { sidebarVisible: sidebarVisible, children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })] }));
}
